import { useQuery } from '@tanstack/react-query';
import { Feature, getFeatures } from '../containers/FeatureManager/api';

type FeatureFlagQueryResult = {
  feature_flags: Feature[];
};

const getAdmFeatures = async (): Promise<FeatureFlagQueryResult> => {
  const response = await getFeatures();

  return response;
};

export const useFeatureFlag = (flagName: string): boolean | undefined => {
  const { data } = useQuery<FeatureFlagQueryResult, Error>({
    queryKey: ['adm_feature_flags'],
    queryFn: () => getAdmFeatures(),
    retry: false,
  });

  if (data === undefined) return undefined;

  const { feature_flags } = data;

  // Check local storage for flag value
  const flagValue = localStorage.getItem(flagName);

  // If the flag is not present in local storage, use the default value from featureFlags object
  if (flagValue === null) {
    return feature_flags.some((e: Feature) => e.name === flagName);
  }

  // Otherwise, parse the flag value from local storage and return it
  return flagValue === 'true';
};
